/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Trim_Duration_TitleInputs */



/**
* | output |
* | --- |
* | "Trim or extend the event duration based on the virtual audio duration" |
*
* @param {Event_Ad_Trim_Duration_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_trim_duration_title = /** @type {((inputs?: Event_Ad_Trim_Duration_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Trim_Duration_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Raccourcir ou prolonger la duree de l'evenement en fonction de la duree de l'audio virtuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kürzen oder verlängern Sie die Ereignisdauer basierend auf der virtuellen Audiodauer.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ridurre o estendere la durata dell'evento in base alla durata dell'audio virtuale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обрежьте или увеличьте продолжительность события в зависимости от виртуальной продолжительности звука.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recortar o ampliar la duración del evento en función de la duración del audio virtual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("根据虚拟音频时长调整活动持续时间。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("仮想オーディオの長さに基づいてイベントの長さを調整または延長します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्चुअल ऑडियो की अवधि के आधार पर इवेंट की अवधि को छोटा या लंबा करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajuste a duração do evento com base na duração do áudio virtual.")
	return /** @type {LocalizedString} */ ("Trim or extend the event duration based on the virtual audio duration")
});